<app-modal
  [title]="'Load products onto card' | trans:'card/add-products-modal/header/title'"
  maxWidth="1200px"
>
  <ng-template>
    <div>
      <app-products-table
        (selectedProductIdsChanged)="selectedProductIds = $event"
      />
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-32">
      <button
        class="button button--md button--secondary text-uppercase flex-grow-1 w-0"
        (click)="close()"
        [disabled]="isSubmitting()"
      >
        {{ 'Cancel' | trans:namespace + '/buttons/cancel' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase flex-grow-1 w-0"
        [disabled]="selectedProductIds.size === 0 || isSubmitting()"
        (click)="submitSelectedProducts()"
      >
        {{ 'Confirm' | trans:namespace + '/buttons/confirm' }}
      </button>
    </div>
  </ng-container>
</app-modal>
